// extracted by mini-css-extract-plugin
module.exports = {"container":"FromRoomvuToVusocial_container__qtHnI","details":"FromRoomvuToVusocial_details__mm3bI","videoWrapper":"FromRoomvuToVusocial_videoWrapper__vQVsT"};